// import { Accordion } from "react-bootstrap";
import { useState, useEffect,useMemo } from "react";
import { useCookies } from "react-cookie";
import http from "../../../common/http-common";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import { toast } from "react-toastify";
import CssClass from "../../../Styles/common.module.css"
// import { useLocation } from "react-router-dom";

const PAGE_NAME = "SystemAuthority.js";
const MODULE_ID = "WEB_USR_001";

const SystemAuthority = () => {
    document.title =  common.c_TITLE + " - System Authority" ;
    const [cookies] = useCookies([]);
    const [userId] = useState(cookies.USER_ID);

    const [reload, setReload] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("Loading...");

    // const location = useLocation();
    // const queryParams = new URLSearchParams(location.search)
    const queryParams = new URLSearchParams(window.location.search);
    const userIdParam = queryParams.get('_userId');

    const [userName, setUserName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [systemDetail, setSystemDetail] = useState([]);
    const [checkBoxValue, setCheckBoxValue] = useState([]);             // Check Box Values Arrays
    const [selectedCheckboxes, setSelectedCheckboxes] = useState({});   // Selected Check Box Object
    const [openItems, setOpenItems] = useState({});

    useEffect(() => {
        let functionName = "";

        try {
            functionName = "useEffect Get User Details"
            onLoadingHandler(true, "Getting User, please wait...");

            http
            .get("api/users/GetEmailDetail?_user=" + userId + "&_userIdParam=" + userIdParam, { timeout: 10000000 })
            .then((response) => {
                if (response.data.length > 0) {
                    setUserName(response.data[0].USER_SHORT_NAME);
                    setCompanyName(response.data[0].ORG_NAME);
                }
            })
            .catch((err) => {
                toast.error("Error on getting user. Please try again.");
                common.c_LogWebError(PAGE_NAME, err.stack);
            })
            .finally(() => {
                onLoadingHandler(false, "Loading...");
            });
        } catch (err) {
            toast.error("Error on getting user. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
        }
    }, [reload, userId, userIdParam])

    useEffect(() => {
        let functionName = "";

        try {
            functionName = "useEffect Get System Details";
            onLoadingHandler(true, "Getting System Details, please wait...");

            setSystemDetail([]);
            const listItems = [];

            http
            .get(`api/users/GetSystemDetail?_user=${userId}&_userIdParam=${userIdParam}`, { timeout: 10000000 })
            .then((response) => {
                if (response.data.length > 0) {
                    response.data.forEach((data, counter) => {
                        listItems.push({
                            key: data.SYSTEM_CONFIG_ID,
                            SYSTEM_CONFIG_ID: data.SYSTEM_CONFIG_ID,
                            ORG_SYSTEM_ID: data.ORG_SYSTEM_ID,
                            // REMARK: data.REMARK,
                            // SYSTEM_MST_NAME: data.SYSTEM_MST_NAME,
                            ORGANIZATION_SYSTEM: data.ORGANIZATION_SYSTEM,
                            SYSTEM_CONFIG_CATEGORY_ID: data.SYSTEM_CONFIG_CATEGORY_ID,
                            SYSTEM_CONFIG_CATEGORY_NAME: data.SYSTEM_CONFIG_CATEGORY_NAME,
                        })
                    });
                }
                setSystemDetail(listItems);
            })
            .catch((err) => {
                toast.error("Error on getting system details. Please try again.");
                common.c_LogWebError(PAGE_NAME, functionName, err);
            })
            .finally(() => {
                onLoadingHandler(false, "Loading...");
            });
        } catch (err) {
            toast.error("Error on getting system details. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
        }
    }, [reload, userId, userIdParam])

    useEffect(() => {
        let functionName = "";

        var isCheckedflag = false;

        try{
            functionName = "useEffect Get System Authority";
            onLoadingHandler(true, "Getting System Authority, please wait...");

            http
            .get("api/users/GetUserEmailAuthority?_user=" + userId + "&_userIdParam=" + userIdParam, { timeout: 10000000 })
            .then((response) => {
                const checkboxValue = [];
                for (var i = 0; i < response.data.length; i++) {
                    if (response.data[i].AUTHORITY_FLAG === "Y") {
                        isCheckedflag = true;
                    } else {
                        isCheckedflag = false;
                    }
                    checkboxValue.push({
                        key: response.data[i].SYSTEM_CONFIG_ID,
                        isCheckedflag: isCheckedflag,
                    });
                    setCheckBoxValue(checkboxValue);
                }
            })
            .catch((err) => {
                toast.error("Error on getting list. Please try again.");
                common.c_LogWebError(PAGE_NAME, functionName, err.stack);
            })
            .finally(() => {
                onLoadingHandler(false, "Loading...");
            });
        } catch (err) {
            toast.error("Error on getting system authority. Please try again.");
            common.c_LogWebError(PAGE_NAME, err.stack);
        }
    }, [reload, userId, userIdParam])

    useEffect(() => {
        // Initialize the selectedCheckboxes state based on checkBoxValue
        const initialSelectedCheckboxes = {};
        checkBoxValue.forEach(item => {
            initialSelectedCheckboxes[item.key] = item.isCheckedflag;
        });
        setSelectedCheckboxes(initialSelectedCheckboxes);
    }, [checkBoxValue]);

    // const groupedSystemDetail = systemDetail.reduce((grouped, item) => {
    //     if (!grouped[item.ORGANIZATION_SYSTEM]) {
    //         grouped[item.ORGANIZATION_SYSTEM] = [];
    //     }
    //     grouped[item.ORGANIZATION_SYSTEM].push(item);
    //     return grouped;
    // }, {});

    const groupedSystemDetail = useMemo(() => {
        return systemDetail.reduce((grouped, item) => {
            if (!grouped[item.ORGANIZATION_SYSTEM]) {
                grouped[item.ORGANIZATION_SYSTEM] = [];
            }
            grouped[item.ORGANIZATION_SYSTEM].push(item);
            return grouped;
        }, {});
    }, [systemDetail]);

    //Open all details 
    useEffect(() => {
        const openAllItems = {};
        const grouped = systemDetail.reduce((grouped, item) => {
            if (!grouped[item.ORGANIZATION_SYSTEM]) {
                grouped[item.ORGANIZATION_SYSTEM] = [];
            }
            grouped[item.ORGANIZATION_SYSTEM].push(item);
            return grouped;
        }, {});
        
        Object.keys(grouped).forEach(key => {
            openAllItems[key] = true;
        });

        setOpenItems(openAllItems);
    }, [systemDetail]);


    // const key = [];
    // const groupedSystemDetail = systemDetail.reduce((grouped, item) => {       
    //     if (!key.includes(item.ORG_SYSTEM_ID)) {
    //         key.push(item.ORG_SYSTEM_ID)
    //         grouped[item.SYSTEM_MST_NAME] = [];
    //     }
    //     grouped[item.SYSTEM_MST_NAME].push(item);
    //     return grouped;
    // }, {})

    const toggleAccordion = (SYSTEM_MST_NAME) => {
        setOpenItems((prevState) => ({
            ...prevState,
            [SYSTEM_MST_NAME]: !prevState[SYSTEM_MST_NAME], // Toggle the state
        }));
    };

    const handleCheckboxChange = (event, SYSTEM_CONFIG_ID) => {

        const { checked } = event.target;
        const isChecked = checked;

        setSelectedCheckboxes((prevState) => ({
            ...prevState,
            [SYSTEM_CONFIG_ID]: checked,
        }))

        if (isChecked === true) {

            const data = {
                USER_ID_PARAM: userIdParam,
                SYSTEM_CONFIG_ID: SYSTEM_CONFIG_ID,
                UPDATE_ID: userId,
                FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: MODULE_ID },
            };

            http
                .post("api/users/InsertEmailAuthority", data, { timeout: common.DEFAULT_TIMEOUT})
                .then((response) => {
                    toast.success("Authority Successfully Inserted.");
                })
                .catch((err) => {
                    common.c_LogWebError(PAGE_NAME, err);                   
                })
        } else {
            const data = {
                USER_ID_PARAM: userIdParam,
                SYSTEM_CONFIG_ID: SYSTEM_CONFIG_ID,
                UPDATE_ID: userId,
                FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: MODULE_ID },
            };
            http
                .put("api/users/DeleteEmailAuthority", data, { timeout: common.DEFAULT_TIMEOUT })
                .then((response) => {
                    toast.success("Authority Successfully Removed.");
                })
                .catch((err) => {
                    toast.error("Failed to update. Please try again.");
                    common.c_LogWebError(PAGE_NAME, err);
                })
        }     
    };
    
    const onLoadingHandler = (load, text) => {
        setLoading(load);
        setLoadingText(text);
    };

    const onReloadHandler = () => {
        setReload(!reload);
    };

    return (
        <>
            <Comp.Header> System Authority </Comp.Header>

            <Comp.SearchPanel>
                <tr>
                    <td style={{ verticalAlign: "middle", width: "10%" }}>User Name</td>
                    <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
                    <td style={{ verticalAlign: "middle", width: "35%" }}>
                        <Comp.Input
                            id="USER_NAME"
                            type="text"
                            className="form-control"
                            value={userName}
                            disabled
                        />
                    </td>
                    <td style={{ verticalAlign: "middle", width: "10%" }}>Company</td>
                    <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
                    <td style={{ verticalAlign: "middle", width: "35%" }}>
                        <Comp.Input
                            id="ORG_NAME"
                            type="text"
                            className="form-control"
                            value={companyName}
                            disabled
                        />
                    </td>
                </tr>
            </Comp.SearchPanel>

            <div style={{padding:"1.5rem 0.5rem 0.5rem 1rem"}}>
                <div className="row">
                    {Object.keys(groupedSystemDetail).map((SYSTEM_MST_NAME, pairIndex) => (
                        <div className="col-md-6 mb-3" key={SYSTEM_MST_NAME}> 
                            <div className={`${CssClass["accordion-item"]}`} key={SYSTEM_MST_NAME}>
                            <div className={CssClass["accordion-header"]} onClick={() => toggleAccordion(SYSTEM_MST_NAME)}>
                                    <h5>{SYSTEM_MST_NAME}</h5>
                                    <div className={`${CssClass.arrow} ${openItems[SYSTEM_MST_NAME] ? CssClass.open : ""}`}></div>
                                </div>
                                {openItems[SYSTEM_MST_NAME] && (
                                    <div className={CssClass["accordion-body"]}>
                                        <div className="row">
                                            {groupedSystemDetail[SYSTEM_MST_NAME].map(({SYSTEM_CONFIG_ID, SYSTEM_CONFIG_CATEGORY_NAME}, innerIndex) => (
                                                <div className="col-md-6" key={innerIndex}>
                                                    <div className={CssClass["dropdown-pair"]}>
                                                        <input
                                                            type="checkbox"
                                                            id={`custom-checkbox-${pairIndex}-${innerIndex}`}
                                                            name={SYSTEM_CONFIG_CATEGORY_NAME}
                                                            value={SYSTEM_CONFIG_CATEGORY_NAME}
                                                            checked={selectedCheckboxes[SYSTEM_CONFIG_ID] || false}
                                                            onChange={(event) =>
                                                                handleCheckboxChange(event, SYSTEM_CONFIG_ID, SYSTEM_CONFIG_CATEGORY_NAME)
                                                            }
                                                        />
                                                        <label htmlFor={`custom-checkbox-${pairIndex}-${innerIndex}`}>
                                                            {SYSTEM_CONFIG_CATEGORY_NAME}
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
                
            {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
            <Comp.AlertPopup />
        </>
    );
};

export default SystemAuthority;
